var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0V2H0V0.0135146L20 0Z",
    fill: "#003349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V11H0V9.01351L20 9Z",
    fill: "#003349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18V20H0V18.0135L20 18Z",
    fill: "#003349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuTwo);
export default __webpack_public_path__ + "static/media/icon-menu-two.7600af4c.svg";
export { ForwardRef as ReactComponent };